import { Hamburger } from '@velocity-exchange/icons';
import useFeatureAnnouncementGlobalState from 'src/components/FeatureAnnouncementTrigger/hooks/useFeatureAnnouncementGlobalState';
import HamburgerWithDot from 'src/components/Icons/HamburgerWithDot';
import TopBarIconButton from 'src/components/TopBar/TopBarIconButton';
import useNavigationStore from 'src/stores/useNavigationStore';

export default function TopBarMobileNavButton() {
	const setNavigationStore = useNavigationStore((s) => s.set);
	const [{ unseenCount }] = useFeatureAnnouncementGlobalState();

	const handleClick = () => {
		setNavigationStore((s) => {
			s.showMobileNavMenu = true;
		});
	};

	return (
		<TopBarIconButton
			icon={unseenCount ? HamburgerWithDot : Hamburger}
			onClick={handleClick}
			dataTestId="mobile-nav-toggle"
		/>
	);
}
